import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { urbandaleConfig } from "./data";

export default function UrbandalePage() {
  return <CityPageTemplate config={urbandaleConfig} />;
}